<template>
    <div>
        <v-container fluid pa-0>
            <v-container fluid grid-list-xl class="toolbar-container">
                <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                    <v-toolbar color="grey lighten-3" elevation="1">
                        <bc-btn-back></bc-btn-back>
                        <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <bc-modal-print
                            ref="print"
                            @close-method="(file_name = null), $refs.print.close()"
                            :file-name="file_name"
                            :no-button="true"
                        ></bc-modal-print>
                        <bc-btn-refresh v-if="person.people_id && person.people_id > 0" @invoke-method="dbGetPerson(true)"></bc-btn-refresh>
                        <v-menu left content-class="no-stripe" v-if="person.people_id && person.people_id > 0">
                            <template slot="activator">
                                <v-btn icon>
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                            </template>
                            <v-list>
                                <v-list-tile @click="printPDF()">
                                    <v-list-tile-title> Print </v-list-tile-title>
                                </v-list-tile>
                                <template v-if="hasPerm('people.update')">
                                    <v-divider class="ml-3 my-0"></v-divider>

                                    <div v-for="item in person_status_options" :key="item.option_id">
                                        <v-list-tile @click="changeStatus(item)" v-if="item.option_id != person.status_id">
                                            <v-list-tile-title>
                                                {{ $t(`lang.mark_as_${item.slug}`) ? $t(`lang.mark_as_${item.slug}`) : `Mark as ${item.option}` }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </div>
                                </template>
                                <template v-if="hasPerm('people.delete')">
                                    <v-divider class="ml-3 my-0"></v-divider>
                                    <v-list-tile @click="$refs.delete_person.openDialog()">
                                        <v-list-tile-title> Delete </v-list-tile-title>
                                    </v-list-tile>
                                </template>
                            </v-list>
                        </v-menu>
                        <bc-tooltip>
                            <template slot="activator">
                                <v-btn icon @mouseup.left="$router.push({ name: 'people' })">
                                    <v-icon>close</v-icon>
                                </v-btn>
                            </template>
                            {{ $t("lang.back_to_list") }}
                        </bc-tooltip>
                    </v-toolbar>
                </v-layout>
            </v-container>

            <v-card-text>
                <v-card elevation="10">
                    <v-card-text>
                        <div v-if="person.status" class="ribbon ribbon-top-right" :class="`ribbon-${person.status_class}`">
                            <span class="ribbon-span">{{ person.status }}</span>
                        </div>
                        <v-form ref="formPerson">
                            <v-flex xs12>
                                <v-text-field
                                    v-focus="person_dialog"
                                    v-model="person.people_id"
                                    :label="$t('lang.people_id')"
                                    :counter="showCounter(person.people_id, 'people.people_id')"
                                    :rules="ifValid('people.people_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.prefix"
                                    :label="$t('lang.prefix')"
                                    :counter="showCounter(person.prefix, 'people.prefix')"
                                    :rules="ifValid('people.prefix')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.first_name"
                                    :label="$t('lang.first_name')"
                                    :counter="showCounter(person.first_name, 'people.first_name')"
                                    :rules="ifValid('people.first_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.middle_name"
                                    :label="$t('lang.middle_name')"
                                    :counter="showCounter(person.middle_name, 'people.middle_name')"
                                    :rules="ifValid('people.middle_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.last_name"
                                    :label="$t('lang.last_name')"
                                    :counter="showCounter(person.last_name, 'people.last_name')"
                                    :rules="ifValid('people.last_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.suffix"
                                    :label="$t('lang.suffix')"
                                    :counter="showCounter(person.suffix, 'people.suffix')"
                                    :rules="ifValid('people.suffix')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.combined_name"
                                    :label="$t('lang.combined_name')"
                                    :counter="showCounter(person.combined_name, 'people.combined_name')"
                                    :rules="ifValid('people.combined_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.nick_name"
                                    :label="$t('lang.nick_name')"
                                    :counter="showCounter(person.nick_name, 'people.nick_name')"
                                    :rules="ifValid('people.nick_name')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.job_title"
                                    :label="$t('lang.job_title')"
                                    :counter="showCounter(person.job_title, 'people.job_title')"
                                    :rules="ifValid('people.job_title')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="person.gender"
                                    :label="$t('lang.gender')"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('people.gender')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.photo_id"
                                    :label="$t('lang.photo_id')"
                                    :counter="showCounter(person.photo_id, 'people.photo_id')"
                                    :rules="ifValid('people.photo_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.photo"
                                    :label="$t('lang.photo')"
                                    :counter="showCounter(person.photo, 'people.photo')"
                                    :rules="ifValid('people.photo')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.entity_phones_id"
                                    :label="$t('lang.entity_phones_id')"
                                    :counter="showCounter(person.entity_phones_id, 'people.entity_phones_id')"
                                    :rules="ifValid('people.entity_phones_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.entity_emails_id"
                                    :label="$t('lang.entity_emails_id')"
                                    :counter="showCounter(person.entity_emails_id, 'people.entity_emails_id')"
                                    :rules="ifValid('people.entity_emails_id')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="person.battery_notify"
                                    :label="`${$t('lang.battery_notify')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('people.battery_notify')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.user_time_zone"
                                    :label="`${$t('lang.user_time_zone')} *`"
                                    :counter="showCounter(person.user_time_zone, 'people.user_time_zone')"
                                    :rules="ifValid('people.user_time_zone')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-select
                                    v-model="person.unit_of_measure"
                                    :label="`${$t('lang.unit_of_measure')} *`"
                                    :items="[]"
                                    item-value="value"
                                    item-text="text"
                                    :rules="ifValid('people.unit_of_measure')"
                                ></bc-select>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.theme"
                                    :label="`${$t('lang.theme')} *`"
                                    :counter="showCounter(person.theme, 'people.theme')"
                                    :rules="ifValid('people.theme')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.notification_method"
                                    :label="`${$t('lang.notification_method')} *`"
                                    :counter="showCounter(person.notification_method, 'people.notification_method')"
                                    :rules="ifValid('people.notification_method')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.language"
                                    :label="`${$t('lang.language')} *`"
                                    :counter="showCounter(person.language, 'people.language')"
                                    :rules="ifValid('people.language')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <v-text-field
                                    v-model="person.invite_token"
                                    :label="$t('lang.invite_token')"
                                    :counter="showCounter(person.invite_token, 'people.invite_token')"
                                    :rules="ifValid('people.invite_token')"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                                <bc-date-picker
                                    v-model="person.invite_expires"
                                    :label="$t('lang.invite_expires')"
                                    :rules="ifValid('people.invite_expires')"
                                ></bc-date-picker>
                            </v-flex>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @mouseup.left="$router.push({ name: 'people' })" flat>{{ $t("lang.cancel") }}</v-btn>
                        <v-btn color="success" @click="savePeople">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-card-text>

            <delete-confirmation-dialog
                ref="delete_person"
                headline="Confirm Delete?"
                :heading="$t('lang.delete_person')"
                :message="$t('lang.delete_person_confirm')"
                @onConfirm="deletePeople()"
            ></delete-confirmation-dialog>
            <delete-confirmation-dialog
                ref="delete_person_details"
                :heading="$t('lang.delete_package')"
                @onConfirm="confirmDeletePersonDetails()"
            ></delete-confirmation-dialog>
        </v-container>
    </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            mobile_list: [{ title: this.$t("lang.print"), action: "printPDF" }],

            formData: {},
            person: {},
            file_name: "",
            dbGetPerson: _.debounce(this.getPerson, 1500, { maxWait: 1500, leading: true, trailing: false }),
            customers: null,
        };
    },
    beforeRouteUpdate(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            this.$store
                .dispatch("fetchPerson", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.person) {
                        this.person = this.assignObj2(data.person, this.rules_people);

                        this.$store.dispatch("fetchSetting", {
                            url: "options?slug=person_status&sort_by=2",
                            method: "get",
                            stateProperty: "person_status_options",
                            dataProperty: "options",
                            commit: true,
                        });

                        this.finishLoader();
                        next();
                    } else {
                        next({ name: "people", replace: true });
                    }
                });
        } else {
            this.finishLoader();
            next();
        }
    },
    beforeRouteEnter(to, from, next) {
        const id = `${to.params.id}`;

        if (id !== "undefined") {
            store
                .dispatch("fetchPerson", {
                    id: id,
                })
                .then((data) => {
                    if (typeof data !== "undefined" && data.person) {
                        next((vm) => {
                            vm.person = vm.assignObj2(data.person, vm.rules_people);

                            store.dispatch("fetchSetting", {
                                url: "options?slug=person_status&sort_by=2",
                                method: "get",
                                stateProperty: "person_status_options",
                                dataProperty: "options",
                                commit: true,
                            });

                            vm.finishLoader();
                        });
                    } else {
                        next({ name: "people", replace: true });
                    }
                });
        } else {
            next((vm) => {
                vm.finishLoader();
            });
        }

        /*store.dispatch("fetchSetting", {
            url: "options?slug=person_status&sort_by=2",
            method: "get",
            stateProperty: "person_status_options",
            dataProperty: "options",
            commit: true,
        });*/
    },
    computed: {
        ...mapState({
            rules_people: (state) => state.people.rules_people,
            person_status_options: (state) => state.settings.person_status_options,
            people: (state) => state.people.people,
            selectedPerson: (state) => state.people.selectedPerson,
        }),
    },
    methods: {
        ...mapActions(["fetchPerson", "savePerson", "deletePerson", "printPerson"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),

        getPerson(pg_refresh = false) {
            this.startLoader();

            this.fetchPerson({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data !== "undefined" && data.person) {
                    this.person = this.assignObj2(data.person, this.rules_people);
                    this.toggleModalLoader(false);
                    this.validationOff();
                    this.finishLoader(pg_refresh);
                }
            });
        },
        printPDF() {
            this.dev_mode ? this.$refs.print.openDialog() : this.toggleGlobalSnackbar(true);

            this.printPerson({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                if (typeof data != "undefined" && data.person) {
                    if (this.dev_mode) {
                        this.file_name = data.person.file_name;
                    } else {
                        this.$refs.print.printReport(data.person.file_name);
                    }

                    if (!this.dev_mode) this.toggleGlobalSnackbar(false);
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        savePeople() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("formPerson")) {
                    let body = this.prepForm(this.person, this.rules_people);

                    this.savePerson({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.person) {
                            this.$router.push({ name: "person", params: { id: data.person.people_id } });
                        } else {
                        }
                    });
                }
            });
        },
        changeStatus(item) {
            this.status_loader = true;
            let body = { people_id: `${this.$route.params.id}`, status_id: item.option_id };

            this.savePeople({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.person) {
                    this.person = this.assignObj2(data.person, this.rules_people);
                }
            });
        },
        deletePeople() {
            this.deletePerson({
                id: `${this.$route.params.id}`,
            }).then((data) => {
                console.log(data);
                if (data && data.code == "200") {
                    this.validationOff();
                    this.$router.push({ name: "people" });
                }
                this.toggleModalLoader(false);
            });
        },
        async refresh(force = false) {
            this.startLoader();

            if (force == true) {
                await this.fetchPerson({
                    id: `${this.$route.params.id}`,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.person) {
                        this.person = this.assignObj2(data.person, this.rules_people);
                        this.toggleModalLoader(false);
                        this.validationOff();
                        this.finishLoader(true);
                    }
                });
            } else {
                this.finishLoader();
            }
        },
    },
    mounted() {
        this.refresh();
    },
    created() {},
};
</script>
